document.addEventListener("DOMContentLoaded", () => {
  const blocks = document.querySelectorAll(".figure-block");

  blocks.forEach((block) => {
    const captions = block.querySelectorAll(".figure-caption");

    captions.forEach((caption) => {
      const rawHTML = caption.innerHTML;

      const match = rawHTML.match(/([+\-]?)(\d{1,3}(?:[.,]\d+)?)/);
      if (!match) return;

      const prefix = match[1];
      const numberText = match[2];
      const numberValue = parseFloat(numberText.replace(",", "."));
      const [before, after] = rawHTML.split(match[0]);

      caption.innerHTML = `
        ${before}
        <span class="prefix">${prefix}</span>
        <span class="countup">${numberText}</span>
        ${after}
      `;

      const span = caption.querySelector(".countup");
      const counterObj = { val: 0 };

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: block,
          start: "top 70%",
          end: "bottom 10%",
          //   scrub: true,
          toggleActions: "play none none none",
        },
      });

      tl.from(caption, {
        yPercent: 100,
        opacity: 0,
        duration: 0.8,
        ease: "expo.out",
      });

      tl.to(
        counterObj,
        {
          val: numberValue,
          duration: 2,
          ease: "power2.out",
          onUpdate: () => {
            const formatted = numberText.includes(",")
              ? counterObj.val.toFixed(1).replace(".", ",")
              : Math.floor(counterObj.val);
            span.textContent = formatted;
          },
        },
        "<"
      );
    });
  });

  ScrollTrigger.refresh();
});
